import { makeStyles, Tab, Tabs } from '@material-ui/core';
import React, { FC } from 'react';
import { OrderingCategory } from 'kiolyn-api';
import { LayoutVariant } from '../../../Core/CommonTypes';
const useStyles = makeStyles(theme => ({
  categories_scroller: {
    whiteSpace: 'pre-wrap'
  },
  categories_container: {
    flex: '1 1 auto',
    display: 'inline-block',
    position: 'relative'
  }
}));

interface CategoryListProps {
  category?: OrderingCategory;
  categories?: OrderingCategory[];
  onCategoryChange?: (category: OrderingCategory) => void;
  variant?: LayoutVariant;
}

const CategoryList: FC<CategoryListProps> = ({
  category,
  categories,
  onCategoryChange,
  variant
}) => {
  const classes = useStyles();
  const displayCategories = categories || [];

  const handleChange = (_e: any, newValue: number) => {
    if (onCategoryChange) {
      onCategoryChange(displayCategories[newValue]);
    }
  };

  return (
    <Tabs
      value={category ? displayCategories.indexOf(category) : 0}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      classes={
        variant === LayoutVariant.kiosk
          ? {
              flexContainer: classes.categories_container,
              scroller: classes.categories_scroller
            }
          : {}
      }
      aria-label="list of categories"
    >
      {displayCategories.map((category, index) => (
        <Tab label={category.name} key={`category-${index}`} />
      ))}
    </Tabs>
  );
};

export default CategoryList;
